/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Files_Error_Causes_UncodedInputs */



/**
* | output |
* | --- |
* | "{count} files with no recorded cause" |
*
* @param {Files_Error_Causes_UncodedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const files_error_causes_uncoded = /** @type {((inputs: Files_Error_Causes_UncodedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Files_Error_Causes_UncodedInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} Dateien ohne erfasste Ursache`)
	return /** @type {LocalizedString} */ (`${i?.count} files with no recorded cause`)
});